module.exports = __webpack_public_path__ + "img/home-image.05174e66.png";